import React from "react";
import GestockAiChat from "./GestockAiChat";

/**
 * Route wrapper for the SPEAKON assistant.
 * The conversation UI lives in GestockAiChat; this keeps the route stable.
 */
export default function AiAssistant() {
  return (
    <div className="mx-auto w-full max-w-5xl">
      <GestockAiChat />
    </div>
  );
}